import { render, staticRenderFns } from "./lostView.vue?vue&type=template&id=5626cdca&scoped=true"
import script from "./lostView.vue?vue&type=script&lang=js"
export * from "./lostView.vue?vue&type=script&lang=js"
import style0 from "./lostView.vue?vue&type=style&index=0&id=5626cdca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626cdca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5626cdca')) {
      api.createRecord('5626cdca', component.options)
    } else {
      api.reload('5626cdca', component.options)
    }
    module.hot.accept("./lostView.vue?vue&type=template&id=5626cdca&scoped=true", function () {
      api.rerender('5626cdca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blameAndPunishment/takeResponsibility/component/lostView.vue"
export default component.exports